import { Injectable } from '@angular/core';
import { DsconfigService, RestConnService, StorageService } from '@services/services.module'
import { Observable, of } from 'rxjs';
import { DayData } from './calendar-day/calendar-day.model';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
@Injectable()
export class CalendarService {
  private calendar_data: object;
  private monthly_imputation: object;
  allFestives: object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    private storage: StorageService,
    public calendar: NgbCalendar
  ) {
    this.calendar_data = {
      'calendar_data': dsConfig.getUrlBase() + '/ess/v1/employee/calendar'
    };
    this.monthly_imputation = {
      'monthly_imputation': dsConfig.getUrlBase() + '/ess/v1/employee/imputation/monthly'
    };
    this.allFestives = {
      'allFestives': dsConfig.getUrlBase() + '/ess/v1/festive/officeId'
    }
  }

  getCalendar(userId: number, year: string, month: string): Observable<any> {
    return this._res.get('calendar_data', { employeeId: userId, year: year, month: month },
      {
        collection: this.calendar_data
      }
    );
  }

  getCalendarBloq(userId: number, year: string, month: string): Observable<any> {
    if (this.storage.get('subtractMonth')) {
      const dateMonth = this.calendar.getToday().month - 1;
      const str = '' +  dateMonth;
      const pad = '00';
      const dateMonthStr = pad.substring(0, pad.length - str.length) + str;
      return this._res.get('calendar_data', { employeeId: userId, year: year, month: dateMonthStr },
        {
          collection: this.calendar_data
        }
      );
    } else {
        this.storage.set('subtractMonth', false);
        return this._res.get('calendar_data', { employeeId: userId, year: year, month: month },
        {
          collection: this.calendar_data
        }
      );
    }
  }

  saveMonth(inputSaveEmployee: any): Observable<any> {
    console.log("inputSaveEmployee",inputSaveEmployee)
    const dataToSend = {
      imputationsEmployee: Object.assign([], inputSaveEmployee)
    };
    return this._res
      .post('monthly_imputation', dataToSend,
        {
          collection: this.monthly_imputation
        }
      );
  }

  getAllFestives(id): Observable<any> {
    return this._res.get('allFestives', { idFesOfi: id },
      {
        collection: this.allFestives
      }
    );
  }
}
